import React from 'react'
import LayoutMain from '../../components/Layout/Main/Main'
import LeftSidedImageCopyItemCollection from "../../Partials/LeftSidedImageCopyItem/collection";
import ProductMiniItemCollection from "../../Partials/ProductMiniItem/Collection";
const leftSidedImageCopyItemCollectionData = [
  {
    descriptionContent : (
      <>
        <p>Think Outside Gardens was established by company director Mick Drower with a vision to provide landscape architecture integrated with an experienced and high quality construction service for residential gardens in Sydney.</p><p>
Delivering a construction project designed by the same company ensures accountability at every stage. It also ensures the project is guaranteed for many years to come.</p><p>
Think Outside Gardens has grown to comprise a team of talented and experienced Landscape architects, project managers, structural landscapers and horticulturalists working together to provide customised and individual gardens. With a great team striving to implement professional, ethical and best practice services our gardens are built to the highest standards. Our practice has a great portfolio of unique design ideas implemented to create landscape Gardens of varying styles. We are big enough to have years of experience yet small enough to be involved in every stage of the project.</p>
      </>
    ),
    image : 'images/about1.jpg',
    title : 'Estimating'
  }
]

const ProductMiniItemCollectionData = [
  {
    image : 'images/contemporary-garden-oasis.jpg',
    title : 'Consultation',
    url : '/consultation'
  },
  {
    image : 'images/contemporary-garden-oasis-4.jpg',
    title : 'Design',
    url : '/design'
  },
  {
    image : 'images/contemporary-garden-oasis-2.jpg',
    title : 'Construction',
    url : '/construction'
  },
  {
    image : 'images/contemporary-garden-oasis-3.jpg',
    title : 'Maintenance',
    url : '/maintenance'
  },
]

const PageEsimating = () => {
  return (
    <LayoutMain>
      <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className=" pt-70 pb-120 pt-sm-30 pb-sm-40">
        <div className="container-3">
            <div className="row">
            <ProductMiniItemCollection data={ProductMiniItemCollectionData} />
            </div>
            </div>
            </section>
    </LayoutMain>
  )
}

export default PageEsimating